/* ─────────────────────────────────────────
   LUMIQ THEME — theme.js
   ───────────────────────────────────────── */

/* ── CART DRAWER ── */
function openCart() {
  document.getElementById('cart-drawer').classList.add('is-open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cart-drawer').classList.remove('is-open');
  document.body.style.overflow = '';
}

/* ── MOBILE MENU ── */
function openMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const overlay = document.getElementById('mobile-menu-overlay');
  const btn = document.getElementById('hamburger-btn');
  menu.classList.add('is-open');
  overlay.classList.add('is-open');
  menu.setAttribute('aria-hidden', 'false');
  btn.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
}
function closeMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const overlay = document.getElementById('mobile-menu-overlay');
  const btn = document.getElementById('hamburger-btn');
  menu.classList.remove('is-open');
  overlay.classList.remove('is-open');
  menu.setAttribute('aria-hidden', 'true');
  btn.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeMobileMenu();
});

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function renderCart() {
  const cart = await fetchCart();
  const itemsEl = document.getElementById('cart-items');
  const totalEl = document.getElementById('cart-total-price');

  document.querySelectorAll('.cart-count').forEach(el => { el.textContent = cart.item_count; });

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
    totalEl.textContent = '$0.00';
    return;
  }

  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <div class="cart-item__img">
        ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
      </div>
      <div class="cart-item__details">
        <div class="cart-item__title">${item.title}</div>
        <div class="cart-item__price">${formatMoney(item.final_price)}</div>
        <div style="font-size:12px; color:#9E9E9E; margin-top:4px;">Qty: ${item.quantity}</div>
      </div>
      <button class="cart-item__remove" onclick="removeItem('${item.key}')">✕</button>
    </div>
  `).join('');

  totalEl.textContent = formatMoney(cart.total_price);
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

async function addToCart(variantId, quantity = 1) {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  });
  await renderCart();
  openCart();
}

/* Ajoute plusieurs articles en une requête (produit principal + add-on) */
async function addItemsToCart(items) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  });
  if (!res.ok) throw new Error('add failed');
  await renderCart();
  openCart();
}

async function removeItem(key) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  } catch (e) {}
  await renderCart();
}

/* ── ADD TO CART BUTTONS ── */
document.addEventListener('DOMContentLoaded', () => {
  renderCart();

  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const variantId = e.currentTarget.dataset.variantId;
      if (variantId) {
        btn.textContent = 'Adding…';
        btn.disabled = true;
        addToCart(parseInt(variantId)).then(() => {
          btn.textContent = '✓ Added!';
          setTimeout(() => {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
          }, 2000);
        });
      }
    });
  });
});

/* ── STICKY HEADER SHADOW ── */
window.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');
  if (!header) return;
  header.style.boxShadow = window.scrollY > 10 ? '0 4px 24px rgba(0,0,0,0.08)' : 'none';
});

/* ── LAZY IMAGES ── */
if ('IntersectionObserver' in window) {
  const imgObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const img = e.target;
        if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
        imgObserver.unobserve(img);
      }
    });
  }, { rootMargin: '200px' });
  document.querySelectorAll('img[data-src]').forEach(img => imgObserver.observe(img));
}

/* ── SCROLL ANIMATIONS ── */
(function () {
  if (!('IntersectionObserver' in window)) return;

  // Single elements — no stagger
  [
    '.section-title',
    '.features-visual',
    '.hero__visual',
    '.hero__floating',
  ].forEach(sel => {
    document.querySelectorAll(sel).forEach(el => el.classList.add('fade-up'));
  });

  // Grid/list children — staggered by position within their parent
  [
    '.stat__item',
    '.step',
    '.feature-item',
    '.ba-card',
    '.product-card',
    '.col-card',
    '.testimonial-card',
    '.trust-item',
  ].forEach(sel => {
    const groups = new Map();
    document.querySelectorAll(sel).forEach(el => {
      const parent = el.parentElement;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(el);
    });
    groups.forEach(children => {
      children.forEach((el, i) => {
        el.classList.add('fade-up');
        el.style.transitionDelay = Math.min(i * 100, 400) + 'ms';
      });
    });
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -32px 0px' });

  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));
})();
